import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/cambiosim',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteCambioSimPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Cambios de SIM</PageTitle>
      <View />
    </>
  );
};

export { ReporteCambioSimPage };
